import { router, usePage } from '@inertiajs/vue3';

export const useRoute = () => {
    function route(name, params) {
        return window.route(name, params);
    }

    function routesAreActive(testedRoutes) {
        const page = usePage();
        const currentRoute = page.props.route;

        return testedRoutes.includes(currentRoute);
    }

    function getBaseUrl() {
        return window.location.origin;
    }

    return {
        route,
        routesAreActive,
        getBaseUrl,
    };
};

export const goBack = () => {
    const page = usePage();
    let previousUrl = page.props.previousUrl;

    if (previousUrl) {
        router.visit(previousUrl, { replace: true });
    } else {
        window.history.back();
    }
};
